import React from "react";
import Routes from "./routes";
import './App.css';
import './i18n';
import ReactGA from 'react-ga';
const TRACKING_ID = "G-FQGNRC7BV0"; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(TRACKING_ID);


function App() {
  return (
    <>
      <Routes/>
    </>
  );
  
}

export default App;